<template>
  <v-layout
    v-if="loading"
    align-center
    justify-center
    column
  >
    <h5>{{ computedLoadingText }}</h5>
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    />
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Loading',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma']),
    computedLoadingText() {
      if (this.text) return this.text;
      return (this.strings[this.idioma].carregando) || 'Carregando...';
    }
  }
};
</script>
